import { useEffect, useState } from 'react';
import { Button } from '@nazka/nazka.mapframe.components';
import { useLocation } from 'react-router-dom';

import { useTranslation } from '@utils/i18n/i18n.consumers';
import { trackEvent } from '@services/analytics.service';

import QuestionComponent from './QuestionComponent/QuestionComponent';
import QuizResultComponent from './QuizResultComponent/QuizResultComponent';

import { questions } from './quiz-component.constants';
import { checkAnswerCorrectness, decodeQuizResultsFromParam } from './quiz-component.utils';

import './quiz-component.styl'

function QuizComponent() {
  const { t } = useTranslation()
  const location = useLocation()
  const [answers, setAnswers] = useState({})
  const [quizResults, setQuizResults] = useState(null)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const resultParam = params.get('quizResult')
    if (!resultParam) return

    const sharedResults = decodeQuizResultsFromParam(resultParam)
    if (sharedResults) setQuizResults(sharedResults)
  }, [location.search])

  const handleAnswerChange = (questionId, selectedOptionId) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: selectedOptionId,
    }))
  }

  const isAllQuestionsAnswered = Object.keys(answers).length === questions.length 
    && Object.values(answers).every(answer => answer !== null)

  const handleSubmit = () => {
    const results = checkAnswerCorrectness(questions, answers)
    setQuizResults(results)
    trackEvent('quiz_submitted');
  }

  return (
    <div className="quiz-component">
      <div className="quiz-component__header">
        <Button
          onClick={() => window.history.back()}
          css={{
            borderRadius: '8px',
            flexDirection: 'row-reverse',
            backgroundColor: 'white',
            '&:hover': {
              color: 'white',
            },
          }}
          layout="outlined"
        >
          {t(quizResults ? 'Go back' : 'Quit quiz')}
        </Button>
      </div>
      
      {quizResults ? (
        <QuizResultComponent quizResults={quizResults} />
      ) : (
        <div>
          <div className="quiz-component__quiz-header">
            <h3>{t('Quiz')}</h3>
          </div>
          <div className="quiz-component__questions-wrapper">
            {questions.map(question => (
              <QuestionComponent 
                key={question.id} 
                question={question} 
                selectedOptionId={answers[question.id] ?? null}
                onAnswerChange={handleAnswerChange}
              />
            ))}
          </div>
          <div className="quiz-component__cta">
            <Button
              disabled={!isAllQuestionsAnswered}
              onClick={handleSubmit}
              css={{
                color: 'white',
                borderRadius: '10px',
                '&:hover': {
                  color: 'white',
                },
                opacity: isAllQuestionsAnswered ? 1 : 0.5,
                cursor: isAllQuestionsAnswered ? 'pointer' : 'not-allowed',
              }}
            >
              {t('Submit')}
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default QuizComponent